import PeticoesPendentes from '@mui/icons-material/Filter9Plus';
import { makeObservable, observable } from 'mobx';
import { Filtro } from './Filtro';

export default class FiltroPeticoesPendentes extends Filtro {
    tipo = 'booleano';
    exibicao = 'checkbox';

    get label() {
        return 'Com petição(ões) pendente(s)';
    }

    getIconeFiltroRapido() {
        return <PeticoesPendentes />;
    }

    filtroRapido = {
        valor: true
    };

    constructor(props) {
        super(props);

        makeObservable(this, {
            filtroRapido: observable
        });
    }

    getValorOpcao(registro) {
        return registro.informacoesAdicionais && registro.informacoesAdicionais.QuantidadePeticoesPendentes > 0;
    }

    getDescricao(valor) {
        return this.labelBooleanoSimNao(valor);
    }
}
